<div class="report-container">
    <!-- Menu -->
    <app-report-sub-menu [menuList]="overViewMenu" (menuChangeValue)="menuChangeValue($event)"></app-report-sub-menu>

    <!-- Overview -->
    <div class="report-tabsection" id="{{ officeInventoryMenuEnum.overview}}"
        [ngClass]="{ 'scroll': currentScroll === officeInventoryMenuEnum.overview}">

        <ng-container *ngIf="overviewLoading">
            <app-skeleton-loader [reportType]="chartView.overView" [height]="'150px'"
                [loaderSize]="3"></app-skeleton-loader>
        </ng-container>

        <div class="report-overview  report-overview-3col" *ngIf="!overviewLoading">
            <!-- Total Properties -->
            <app-overview-card [card_title]="'reports.totalProperties'" [total_current]="overviewData?.total_properties"
                [untillDate]="overviewData?.untillDate" [developerText]="overviewData?.developed_properties"
                [underConstructionText]="overviewData?.under_construction_properties"
                [showDeveloped]="true"></app-overview-card>
            <!-- Constructed Units -->
            <app-overview-card [card_title]="'reports.constructedUnits'"
                [total_current]="overviewData?.existing_inventory"
                [untillDate]="overviewData?.untillDate"></app-overview-card>
            <!-- Supply - Under Construction pipeline (sqm) -->
            <app-overview-card [card_title]="'reports.supplyUnderConstructionUnits'"
                [total_current]="overviewData?.captive_office_share"
                [total_current]="overviewData?.supply_under_construction"
                [untillDate]="overviewData?.untillDate"></app-overview-card>
        </div>

        <!-- Transaction Rate - Apartment Chart -->
        <div class="report-model report-rentrate">
            <div class="report-model-header">
                <div class="info">
                    <h3>{{'reports.transactionRateApartment' | translate}} ({{CurrencyCode
                        | translate}}/{{'reports.sqm_unit' | translate}})
                    </h3>
                </div>
            </div>
            <app-line-chart [label]="'reports.apartment' | translate" [name]="'apartment'"></app-line-chart>
        </div>

        <!-- Transaction Rate - House & Villa Chart -->
        <div class="report-model report-rentrate">
            <div class="report-model-header">
                <div class="info">
                    <h3>{{'reports.transactionRateHouseVilla' | translate}} ({{CurrencyCode
                        | translate}}/{{'reports.sqm_unit' | translate}})
                    </h3>
                </div>
            </div>
            <app-line-chart [label]="'reports.houseVilla' | translate" [name]="'house-villa'"></app-line-chart>
        </div>

        <!-- Transaction Rate - Land Chart -->
        <div class="report-model report-rentrate">
            <div class="report-model-header">
                <div class="info">
                    <h3>{{'reports.transactionRateLand' | translate}} ({{CurrencyCode
                        | translate}}/{{'reports.sqm_unit' | translate}})
                    </h3>
                </div>
            </div>
            <app-line-chart [label]="'Land' | translate" [name]="'land'"></app-line-chart>
        </div>

        <!-- Apartment - Rent Rate, Rental Yield  -->
        <div class="report-model report-rentrate">
            <div class="report-model-header">
                <div class="info">
                    <h3>{{'reports.apartmentRentRate' | translate}} ({{CurrencyCode
                        | translate}}/{{'reports.sqm_unit' | translate}}), {{'reports.rentalYield' | translate}}
                    </h3>
                </div>
            </div>
            <app-line-bar-chart [lineLabel]="'reports.rentalYield' | translate"
                [barLabel]="'reports.rentRate' | translate" [name]="'rental-yield'"></app-line-bar-chart>
        </div>
    </div>

    <!-- Property Unit Summary - Transaction -->
    <div class="report-tabsection"
        [ngClass]="{ 'scroll': currentScroll === officeInventoryMenuEnum.propertyUnitSummaryTransaction}"
        id="{{ officeInventoryMenuEnum.propertyUnitSummaryTransaction }}">
        <div class="report-model">
            <app-datatable-title [isShowCount]="false" [title]="'reports.propertyUnitSummaryTransaction' | translate"
                [count]="transactionCount"></app-datatable-title>
            <app-residential-prime-transaction [showLoader]="!transactionLoading" [tableColumns]="transactionColumns"
                [dropDownOption]="tableDropdown">
            </app-residential-prime-transaction>
        </div>
    </div>

    <!-- Land - Transaction -->
    <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === officeInventoryMenuEnum.landTransaction}"
        id="{{ officeInventoryMenuEnum.landTransaction }}">
        <div class="report-model">
            <app-datatable-title [isShowCount]="false" [title]="'reports.landTransaction' | translate"
                [count]="landCount"></app-datatable-title>
            <app-residential-prime-land [showLoader]="!landLoading" [tableColumns]="landColumns"
                [dropDownOption]="tableDropdown">
            </app-residential-prime-land>
        </div>
    </div>

    <!-- Property Unit Summary - Rental -->
    <div class="report-tabsection"
        [ngClass]="{ 'scroll': currentScroll === officeInventoryMenuEnum.propertyUnitSummaryRental}"
        id="{{ officeInventoryMenuEnum.propertyUnitSummaryRental }}">
        <div class="report-model">
            <app-datatable-title [isShowCount]="false" [title]="'reports.propertyUnitSummaryRental' | translate"
                [count]="rentalCount"></app-datatable-title>
            <app-residential-prime-rental [showLoader]="!rentalLoading" [tableColumns]="rentalColumns"
                [dropDownOption]="tableDropdown">
            </app-residential-prime-rental>
        </div>
    </div>

    <!-- Project Summary Table -->
    <div class="report-tabsection"
        [ngClass]="{ 'scroll': currentScroll === officeInventoryMenuEnum.projectSummaryTable}"
        id="{{ officeInventoryMenuEnum.projectSummaryTable }}">
        <div class="report-model">
            <app-datatable-title [isShowCount]="false" [title]="'reports.projectSummaryTable' | translate"
                [count]="projectCount"></app-datatable-title>
            <app-residential-prime-project [showLoader]="!projectLoading" [tableColumns]="projectColumns"
                [dropDownOption]="tableDropdown">
            </app-residential-prime-project>
        </div>
    </div>

</div>